export const MapsSdkVersion = {
  google: '3.55',
  mapbox: '2.9.2'
};